









































































































export default function (Component) {
  Component.options.__source = "src/components/d2-container-passenger-project-search/index.vue"
}
